// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import {
  ERR_CREATE_COMMERCIAL_AGREEMENT,
  SUC_CREATE_COMMERCIAL_AGREEMENT,
} from '../../../utils/strings';
import { useCreateSubmission } from '../ledger/useSubmission';

export const useCreateCommercialAgreement = () => {
  const { submit } = useCreateSubmission(
    CommercialAgreementOffer,
    SUC_CREATE_COMMERCIAL_AGREEMENT,
    ERR_CREATE_COMMERCIAL_AGREEMENT,
  );
  return submit;
};
